import { GAME_IMAGE_SIZES } from '../Games/Game/Game.content';

export const MAX_COLUMNS_COUNT = 12;
export const COLUMN_MIN_WIDTH = GAME_IMAGE_SIZES.square.width;
export const IMAGES_GAP_TOKEN = 'space-100';
export const IMAGES_CONTAINER_HEIGHT = 220;
export const VISIBLE_RANGE = [-3, -2, -1, 0, 1, 2, 3]; // 0 indicates the current visible index. The other numbers are buffers
